





































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
const columns = [
  { title: '排序', dataIndex: 'sort', scopedSlots: { customRender: 'sort' } },
  { title: '分类名称', dataIndex: 'name', key: 'name', scopedSlots: { customRender: 'name' }  },
  { title: '商品数量', dataIndex: 'ware_count', key: 'ware_count' },
  { title: '是否显示', dataIndex: 'is_show', key: 'is_show', scopedSlots: { customRender: 'is_show' } },
  { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } },
];
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  list: `${FCAPI}/shang/ware/category`,
  sort: `${FCAPI}/shang/ware/category/sort`,
};
@Component
export default class CategoryList extends Vue {
  is_loading: boolean = false;
  expand_keys: number[] = [6];
  sort: number = 0;
  show_delete: boolean = false;
  popup_id: number = 0;
  table_data: any = [];
  innerData: any = { detail: [{ id: 2, sort: 2 }] };
  modal_title: string = '';
  show_modal: boolean = false;
  form: any;
  content: string = '';
  tag = 1;
  delete_id: number = 0;
  edit_id = 0;
  err_content: string = '';
  show_err: boolean = false;
  second_id: number = 0;
  is_show: number = 1;
  maxLength: number = 4;
  isShowSort(record: any) {
    return record.id === this.popup_id;
  }
  addFirst() {
    this.maxLength = 4;
    this.second_id = 0;
    this.tag = 1;
    this.form.resetFields();
    this.show_modal = true;
    this.is_show = 1;
    this.modal_title = '新增一级分类';
  }
  async submit() {
    this.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        const send_data = {
          name: values.category_name,
          parent_id: this.second_id,
          sort: values.sort,
          is_show: this.is_show,
        };
        if (this.tag === 1 || this.tag === 2) {
          const res = await this.$axios.post(API.list, send_data);
          if (res.data.status === 200) {
            this.$message.success('新建成功');
          } else {
            this.$message.error(res.data.message);
          }
        } else {
          const res = await this.$axios.put(`${API.list}/${this.edit_id}`, send_data);
          if (res.data.status === 200) {
            this.$message.success('编辑成功');
          } else {
            this.$message.error(res.data.message);
          }
        }
        this.show_modal = false;
        this.search();
      }
    });
  }
  deleteCategory(record: any) {
    this.delete_id = record.id;
    this.show_delete = true;
    this.content = `确定要删除${record.name}分类吗？`;
  }
  async confirmDelete() {
    const res = await this.$axios.delete(`${API.list}/${this.delete_id}`);
    if (res.data.status === 200) {
      this.$message.success('删除成功');
      this.show_delete = false;
      this.search();
    } else {
      this.show_err = true;
      this.err_content = res.data.message;
      this.$message.error(res.data.message);
    }
  }
  async search() {
    this.is_loading = true;
    const res = await this.$axios.get(API.list);
    res.data.data.forEach((item: any) => {
      item.is_parent = true;
    });
    this.table_data = res.data.data;
    console.log(this.table_data);
    this.is_loading = false;
  }
  get columns() {
    return columns;
  }
  cancel() {
    this.popup_id = 0;
  }
  beforeCreate() {
    this.form = this.$form.createForm(this);
  }
  edit(record: any) {
    this.maxLength = 4 - record.name.length;
    this.edit_id = record.id;
    this.tag = 3;
    this.second_id = record.parent_id;
    this.show_modal = true;
    this.modal_title = `编辑分类`;
    this.$nextTick(() => {
      this.form.setFieldsValue({
        category_name: record.name,
        sort: record.sort,
      });
    });
    this.is_show = record.is_show;
  }
  change(e: any) {
    this.$nextTick(() => {
      console.log(this.form.getFieldValue('category_name'));
      this.maxLength = 4 - this.form.getFieldValue('category_name').length;
    });
  }
  created() {
    this.search();
  }
  async changeSort(record: any) {
    if (this.sort % 1 !== 0 || this.sort <= 0) {
      this.$message.error('排序值须为正整数');
      return;
    }
    const res = await this.$axios.put(`${API.sort}/${record.id}`, { sort: this.sort });
    if (res.data.status === 200) {
      this.$message.success('修改成功');
      this.search();
      this.popup_id = 0;
    } else {
      this.popup_id = 0;
      this.$message.error(res.data.message);
    }
  }
  addSecondTag(record: any) {
    this.maxLength = 4;
    this.tag = 2;
    this.second_id = record.id;
    this.form.resetFields();
    this.is_show = 1;
    this.modal_title = `新增${record.name}的二级分类`;
    this.show_modal = true;
  }
  show_sort_change(record: any) {
    this.sort = record.sort;
    this.popup_id = record.id;
  }
}
